// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/mobile.scss
// module id = 242
// module chunks = 0